import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Tenant Details (/tenant/:tenantID)
 */
export const tenantDetailsTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_TenantDetails_Welcome_Title"),
    description: t("Tour_TenantDetails_Welcome_Description"),
    target: () => queryTourTarget("tenant-details-header"),
    placement: "bottom",
  },
  {
    title: t("Tour_TenantDetails_Tabs_Title"),
    description: t("Tour_TenantDetails_Tabs_Description"),
    target: () => queryTourTarget("tenant-details-tabs"),
    placement: "bottom",
  },
  {
    title: t("Tour_TenantDetails_ShadowInvite_Title"),
    description: t("Tour_TenantDetails_ShadowInvite_Description"),
    target: () => queryTourTarget("tenant-shadow-invite"),
    placement: "left",
  },
  {
    title: t("Tour_TenantDetails_Info_Title"),
    description: t("Tour_TenantDetails_Info_Description"),
    target: () => queryTourTarget("tenant-info"),
    placement: "top",
  },
];
